// === CONFIG ===
const API_URL = "https://wuname.vercel.app/api/generate-wuname";
const MAPBOX_TOKEN = "pk.eyJ1IjoidHlzemFsIiwiYSI6ImNtZXJsaXJkeDA3cngya3B4cnJucWVkZGgifQ.NecxufyGQPXc9sV34tcVcw";


// --- Wu-Name API ---
async function getWuName(payload) {
  const res = await fetch(API_URL, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!res.ok) throw new Error("Wu-name fetch failed");
  const data = await res.json();
  return data.wuName;
}

// --- Mapbox helpers (city / region / country) ---
const toCityRegionCountry = (feat) => {
  const city = feat.text || "";
  const ctx = (feat.context || []).reduce((a, c) => {
    a[c.id.split(".")[0]] = c;
    return a;
  }, {});

  const region = (ctx.region && ctx.region.text) || "";
  const country = (ctx.country && ctx.country.text) || "";

  // If US, return "City, State, Country" — otherwise "City, Region, Country"
  if (country === "United States" && region) {
    return `${city}, ${region}, ${country}`;
  } else if (region && country) {
    return `${city}, ${region}, ${country}`;
  } else if (country) {
    return `${city}, ${country}`;
  } else {
    return feat.place_name || city;
  }
};

async function fetchPlaces(q) {
  const url = new URL("https://api.mapbox.com/geocoding/v5/mapbox.places/" + encodeURIComponent(q) + ".json");
  url.searchParams.set("types", "place");
  url.searchParams.set("autocomplete", "true");
  url.searchParams.set("language", "en");
  url.searchParams.set("limit", "5");
  url.searchParams.set("access_token", MAPBOX_TOKEN);
  const r = await fetch(url);
  if (!r.ok) return [];
  const j = await r.json();
  return j.features || [];
}

async function reverseGeocode(lat, lon) {
  const url = new URL(`https://api.mapbox.com/geocoding/v5/mapbox.places/${lon},${lat}.json`);
  url.searchParams.set("types", "place");
  url.searchParams.set("language", "en");
  url.searchParams.set("access_token", MAPBOX_TOKEN);
  const r = await fetch(url);
  if (!r.ok) return null;
  const j = await r.json();
  return j.features?.[0] || null;
}


document.addEventListener("DOMContentLoaded", () => {
  const mainForm = document.getElementById("wu-name-form");
  const tryForm = document.getElementById("try-again-form");
  const resultBlock = document.getElementById("wu-result");
  const output = document.getElementById("wu-name-output");
  const userOutput = document.getElementById("user-name-output");
  const tryAgainBtn = document.getElementById("try-again-btn");

  const locInput = document.getElementById("location");
  const useBtn = document.getElementById("use-my-location");
  const suggestEl = document.getElementById("location-suggest");
  let suggestTimer, lastResults = [];

  if (locInput && suggestEl) {
    locInput.addEventListener("input", () => {
      const q = locInput.value.trim();
      clearTimeout(suggestTimer);
      if (!q || q.length < 2) { suggestEl.style.display = "none"; return; }
      suggestTimer = setTimeout(async () => {
        lastResults = await fetchPlaces(q);
        suggestEl.innerHTML = lastResults.map((f, i) => `<li data-i="${i}">${toCityRegionCountry(f)}</li>`).join("");
        suggestEl.style.display = lastResults.length ? "block" : "none";
      }, 200);
    });

    suggestEl.addEventListener("click", (e) => {
      const li = e.target.closest("li"); if (!li) return;
      const i = Number(li.dataset.i); const feat = lastResults[i]; if (!feat) return;
      locInput.value = toCityRegionCountry(feat);
      suggestEl.style.display = "none";
    });

    document.addEventListener("click", (e) => {
      if (!suggestEl.contains(e.target) && e.target !== locInput) suggestEl.style.display = "none";
    });
  }

  if (useBtn && locInput) {
    useBtn.addEventListener("click", () => {
      if (!navigator.geolocation) { alert("Geolocation not supported."); return; }
      useBtn.disabled = true;
      navigator.geolocation.getCurrentPosition(async (pos) => {
        try {
          const feat = await reverseGeocode(pos.coords.latitude, pos.coords.longitude);
          if (feat) locInput.value = toCityRegionCountry(feat);
        } catch { alert("Could not get location."); }
        finally { useBtn.disabled = false; }
      }, () => { alert("Location permission denied."); useBtn.disabled = false; }, { enableHighAccuracy: true, timeout: 8000 });
    });
  }

  // --- Try-again location wiring (autocomplete + inside arrow) ---
  (() => {
    const locInput2   = document.getElementById("try-location");
    const useBtn2     = document.getElementById("try-use-my-location");
    const suggestEl2  = document.getElementById("try-location-suggest");
    if (!locInput2 || !suggestEl2) return;

    let suggestTimer2, lastResults2 = [];

    locInput2.addEventListener("input", () => {
      const q = locInput2.value.trim();
      clearTimeout(suggestTimer2);
      if (!q || q.length < 2) { suggestEl2.style.display = "none"; return; }
      suggestTimer2 = setTimeout(async () => {
        try {
          lastResults2 = await fetchPlaces(q);
          suggestEl2.innerHTML = lastResults2
            .map((f, i) => `<li data-i="${i}">${toCityRegionCountry(f)}</li>`)
            .join("");
          suggestEl2.style.display = lastResults2.length ? "block" : "none";
        } catch { suggestEl2.style.display = "none"; }
      }, 200);
    });

    suggestEl2.addEventListener("click", (e) => {
      const li = e.target.closest("li"); if (!li) return;
      const i = Number(li.dataset.i);
      const feat = lastResults2[i]; if (!feat) return;
      locInput2.value = toCityRegionCountry(feat);
      suggestEl2.style.display = "none";
    });

    document.addEventListener("click", (e) => {
      if (!suggestEl2.contains(e.target) && e.target !== locInput2) {
        suggestEl2.style.display = "none";
      }
    });

    if (useBtn2) {
      useBtn2.addEventListener("click", () => {
        if (!navigator.geolocation) { alert("Geolocation not supported."); return; }
        useBtn2.disabled = true;
        navigator.geolocation.getCurrentPosition(async (pos) => {
          try {
            const feat = await reverseGeocode(pos.coords.latitude, pos.coords.longitude);
            if (feat) locInput2.value = toCityRegionCountry(feat);
          } catch { alert("Could not get location."); }
          finally { useBtn2.disabled = false; }
        }, () => { alert("Location permission denied."); useBtn2.disabled = false; }, {
          enableHighAccuracy: true, timeout: 8000
        });
      });
    }
  })();

  // --- Main submit ---
  mainForm.addEventListener("submit", async (e) => {
    e.preventDefault();
    const name = document.getElementById("name").value.trim();
    const location = document.getElementById("location").value.trim();
    const email = document.getElementById("email").value.trim();
    const consent = document.getElementById("privacy-consent").checked;

    if (!name || !location || !email) return alert("Fill all fields.");
    if (!consent) return alert("You must consent to the privacy policy and terms.");

    const [firstName, ...rest] = name.split(" ").filter(Boolean);
    const lastName = rest.length >= 2 ? rest.slice(-1)[0] : (rest[0] || "");

    try {
      const wuName = await getWuName({ name, location, email, consent, firstName: firstName || "", lastName: lastName || "" });
      output.innerHTML = `<span>${wuName}</span>`;
      userOutput.innerText = name;
      sessionStorage.setItem("wuName", wuName);
      sessionStorage.setItem("location", location);
      mainForm.style.display = "none";
      document.getElementById("wu-form-header").style.display = "none";
      resultBlock.style.display = "flex";
    } catch {
      alert("Something went wrong.");
    }
  });

  // --- Try again flow ---
  tryAgainBtn.addEventListener("click", () => {
    resultBlock.style.display = "none";
    tryForm.style.display = "flex";
    document.getElementById("try-name").value = userOutput.innerText;
    document.getElementById("try-location").value = "";
  });

  tryForm.addEventListener("submit", async (e) => {
    e.preventDefault();
    const name = document.getElementById("try-name").value.trim();
    const location = document.getElementById("try-location").value.trim();
    if (!name || !location) return alert("Both fields required.");
    try {
      const wuName = await getWuName({ name, location });
      output.innerHTML = `<span>${wuName}</span>`;
      userOutput.innerText = name;
      sessionStorage.setItem("wuName", wuName);
      sessionStorage.setItem("location", location);
      tryForm.style.display = "none";
      document.getElementById("wu-form-header").style.display = "none";
      resultBlock.style.display = "flex";
    } catch {
      alert("Try again failed.");
    }
  });
});